import * as React from 'react';

import { useLiveRef } from './useLiveRef';

/**
 * Attach a function to be called before the user closes its browser. Optionally accepts an
 * onCancel handler. If the user cancels the action, the function will be called.
 */
export function useBeforeUnload(
    onBeforeUnload: (e?: Event) => string | null,
    onCancel?: () => void
) {
    const refs = useLiveRef({ onBeforeUnload, onCancel });
    React.useEffect(() => {
        const callback = (event: Event) => {
            const { onBeforeUnload, onCancel } = refs.current;
            const message = onBeforeUnload(event);

            if (message == null) {
                return null;
            }

            if (onCancel) {
                // https://stackoverflow.com/questions/4650692/way-to-know-if-user-clicked-cancel-on-a-javascript-onbeforeunload-dialog
                setTimeout(() => {
                    setTimeout(() => {
                        onCancel();
                    }, 1000);
                }, 1);
            }

            // @ts-ignore
            event.returnValue = message;

            return message;
        };

        window.addEventListener('beforeunload', callback);

        return () => {
            window.removeEventListener('beforeunload', callback);
        };
    }, [refs]);
}
